
export default function Unauthorized() {
	return (
		<p>Unauthorized</p>
	);

}